import { initializePlatformBrowser } from "@outschool/platform-browser/init";
// these are set up as globals on marketplace.tsx
initializePlatformBrowser({
  env: (window as any).OUTSCHOOL_SERVER.PLATFORM_ENV,
  sentry: (window as any).Sentry,
});
export function skipTreeshake() {
  // no-op; exists just to keep this file from being removed by webpack tree-shaking.
}
